// extracted by mini-css-extract-plugin
export var ctaContainer = "dMSideBySidePageHeader-module--ctaContainer--033fb";
export var ctaWrap = "dMSideBySidePageHeader-module--ctaWrap--b03a1";
export var dark = "dMSideBySidePageHeader-module--dark--05ca0";
export var emailCapture = "dMSideBySidePageHeader-module--emailCapture--f3b99";
export var eyebrow = "dMSideBySidePageHeader-module--eyebrow--51a1b";
export var headline = "dMSideBySidePageHeader-module--headline--4799d";
export var imageContainer = "dMSideBySidePageHeader-module--imageContainer--f0913";
export var labelImage = "dMSideBySidePageHeader-module--labelImage--68f1c";
export var sideBySide = "dMSideBySidePageHeader-module--sideBySide--55572";
export var sideBySideHeader = "dMSideBySidePageHeader-module--sideBySideHeader--4d0af";
export var sideBySidePageRow = "dMSideBySidePageHeader-module--sideBySidePageRow--823c0";
export var subheading = "dMSideBySidePageHeader-module--subheading--a7a19";